import React, { useEffect } from "react";
import Logo from '../assets/Logo.png'
import { colors } from "../utils/constants";
import { useSelector } from "react-redux";


const Header = () => {

    const staff = useSelector((state) => state.staff.value)

    return (<div className="header">
        <img src={Logo} className="logo" />
        <h1 style={{ color: colors.teal }}>2023</h1>
        <h1 style={{ color: colors.mustard, textAlign: 'center' }}> Fast track your day... </h1>
        <h1 style={{ color: colors.mustard, textAlign: 'center' }}> Pre-book your rides! </h1>
        {staff &&
            <div style={{ marginRight: 'auto' }} id="back-to-admin">
                <button className="textButton" style={{ marginRight: 'auto' }} onClick={() => window.open('/admin', '_self')}> {'<-Back to Admin'}</button>
            </div>}
    </div>)
}

export default Header